import React from "react";
import { useCreateDashboardStore } from ".";
import SingleActuatorCharts from "./ActuatorWidget/SingleActuatorCharts";
import MultipleActuatorCharts from "./ActuatorWidget/MultipleActuatorCharts";
import CorrelationCharts from "./ActuatorWidget/CorrelationCharts";
import { WidgetItem } from "types";
import { WidgetType } from "../utils/widgetConfig";

interface ActuatorChartsProps {
    widget?: WidgetItem;
}

const ActuatorCharts: React.FunctionComponent<ActuatorChartsProps> = ({
    widget,
}) => {
    const { widget: storeWidget } = useCreateDashboardStore();
    const effectiveWidget = widget || storeWidget;
    const widgetType = effectiveWidget?.widgetType;

    // Route to appropriate component based on chart type
    if (widgetType === WidgetType.ACTUATOR_CHART_MULTIPLE) {
        return <MultipleActuatorCharts />;
    }

    if (widgetType === WidgetType.ACTUATOR_CHART_CORRELATION) {
        return <CorrelationCharts />;
    }

    // Default to single actuator chart
    return <SingleActuatorCharts />;
};

export default React.memo(ActuatorCharts);
